import React from "react";

const AddMoreIconsCTA = ({ onClick }) => (
    <button className="add-more-icons-cta" onClick={onClick}>
        Add more icons
    </button>
);

export default AddMoreIconsCTA;
